// extracted by mini-css-extract-plugin
export default {"l":"_8693948851"};